export const siteTitle = import.meta.env.VITE_SITE_TITLE;
export const siteSupport = import.meta.env.VITE_SITE_SUPPORT;
export const siteLink = import.meta.env.VITE_SITE_LINK;
export const siteApk = import.meta.env.VITE_SITE_APK;
// export const downloadUrl = location.origin + siteApk;
export const downloadUrl = siteApk;

export default {
    siteTitle,
    siteSupport,
    siteLink,
    siteApk,
    downloadUrl,
}